module.exports = __webpack_public_path__ + "img/Unidad19-2.21196e0f.png";